// module.exports = {
import { EventBus } from './services/event-bus';
import constantMessages from "@/messages";
import moment from 'moment';
import {
    displayErrorMessage
} from './formvalid.js';

const Utils = {
	dropzoneComponents: [],

	bindDropzone(e, name, formURL, isFormDropzone) {
		Dropzone.autoDiscover = false;
		var mydropzone = $(e)[0];
		var maxFilesTobeUploaded = $(e).attr("maxfiles");
		var acceptedFiles1 = this.getFileExtensions($(e));
		var self = this;
		if(mydropzone && mydropzone.dropzone) {
			let parentDiv = mydropzone.parentNode.parentNode;
			$(parentDiv).css({"pointer-events":''});
			mydropzone.dropzone.options.url = formURL;
			mydropzone.dropzone.options.paramName = $(parentDiv).attr("name");
			mydropzone.dropzone.options.autoProcessQueue =  false;
			mydropzone.dropzone.options.parallelUploads =  10;
			mydropzone.dropzone.options.addRemoveLinks =  true;
			mydropzone.dropzone.options.uploadMultiple =  true;
			mydropzone.dropzone.options.acceptedFiles = this.getFileExtensions($(parentDiv));
			mydropzone.dropzone.options.maxFiles =  $(parentDiv).attr("maxfiles");
			if (isFormDropzone) {
				self.dropzoneComponents.push(mydropzone.dropzone);
			}
			let isDisabled = $(parentDiv).attr("disabled");
			if (isDisabled != null) {
				mydropzone.dropzone.disable();
			}
			this.assignProperties(parentDiv, mydropzone);
		}
		else {
			mydropzone = new Dropzone($(e)[0], {
				url: formURL,
				paramName: name,
				autoProcessQueue: false,
				parallelUploads: 10,
				addRemoveLinks: true,
				uploadMultiple: true,
				acceptedFiles: acceptedFiles1,
				maxFiles: maxFilesTobeUploaded,
				init: function () {
					mydropzone = this;
					if (isFormDropzone) {
						self.dropzoneComponents.push(this);
					}
				},
			});
	
			let isDisabled = $(e).attr("disabled");
			if (isDisabled != null) {
				mydropzone.disable();
			}
			return mydropzone;
		}
	},

	assignProperties(source, target) {
		(source.attributes).forEach(attr => {
			if(attr.nodeName == 'class' || attr.nodeName == 'name' || attr.nodeName == 'options') {
				return;
			}
			target.setAttribute(attr.nodeName, attr.nodeValue)
		})
	},

	applyFixedHeaderConfiguration(vueComponentObj) {
		let theme = vueComponentObj.$store.getters.getThemeData;
		if (theme.fixedHeader) {
			$(".mcc-page-header").addClass("fixedPageHeader");
		} else {
			$(".mcc-page-header").removeClass("fixedPageHeader");
		}
	},

	getFileExtensions(e) {
		let fileExt = $(e).attr("filetypes");
		let stringToRetn = "";
		if (fileExt != null) {
			let fileArr = JSON.parse(fileExt);
			for (let i = 0; i < fileArr.length; i++) {
				stringToRetn += "." + fileArr[i];
				if (i != fileArr.length - 1) {
					stringToRetn += ", ";
				}
			}
		}
		return stringToRetn;
	},

	isElementHidden(el) {
		return (el.offsetParent === null)
	},
	updateSVG(id) {
		$("#" + id + " use").each(function () {
			var linkRef = $(this).attr("xlink:href");

			var currentObj = $(this);
			$.each(currentObj[0].attributes, function (ind, attr) {
				if (attr.name && attr.name.indexOf(":href") != -1) {
					linkRef = attr.value;
				}
			});
			if (linkRef && linkRef == "#raphael-marker-classic") {
				currentObj.attr("xlink:href", "#raphael-marker-classic");
				currentObj.attr("href", "#raphael-marker-classic");
			} else if (linkRef && linkRef == "#raphael-marker-diamond") {
				currentObj.attr("xlink:href", "#raphael-marker-diamond");
				currentObj.attr("href", "#raphael-marker-diamond");
			}
		});
	},
	trimSvgWhitespace() {
		var svgTag = $("#newSvgContainer svg");

		if (svgTag && svgTag[0]) {
			var svg = svgTag[0];
			$(svg).removeAttr("width");
			var isEdge = this.isEdgeBrowser();
			var isIE = this.isIEBrowser();
			if (!isIE || isEdge) {
				$(svg).removeAttr("height");
			}

			var bbox = svg.getBBox();
			var viewBox = [bbox.x, bbox.y, bbox.width, bbox.height].join(" ");
			svg.setAttribute("viewBox", viewBox);
		}
	},
	isEdgeBrowser() {
		var sAgent = window.navigator.userAgent;
		var edge = sAgent.indexOf("Edge/");
		if (edge > 0) {
			// Edge (IE 12+) => return version number
			return true;
		}
		return false;
	},
	isIEBrowser() {
		var sAgent = window.navigator.userAgent;
		var version = sAgent.indexOf("MSIE");
		var verNum = 0;
		// If IE, return version number.
		if (version > 0)
			verNum = parseInt(sAgent.substring(version + 5, sAgent.indexOf(".", version)));
		// If IE 11 then look for Updated user agent string.
		else if (!!navigator.userAgent.match(/Trident\/7\./)) verNum = 11;

		return verNum > 0;
	},
	checkIsValidDropzone(dropzone, form) {
		let dropName = dropzone.options.paramName;
		if (!this.isElementHidden(dropzone.element)) {
			let maxFileCount = 0;
			if ($(dropzone.element).attr("maxfiles") != null) {
				maxFileCount = parseInt($(dropzone.element).attr("maxfiles"));
			}

			let maxfilesize = 0;
			if ($(dropzone.element).attr("maxfilesize") != null) {
				maxfilesize = parseInt($(dropzone.element).attr("maxfilesize"));
			}

			let fileExt = $(dropzone.element).attr("filetypes");
			let fileArr = [];
			if (fileExt != null) {
				fileArr = JSON.parse(fileExt);
			}

			var isRequired = $(dropzone.element).attr("required");
			if (isRequired != null) {
				if (dropzone.files.length == 0) {
					EventBus.$emit('error-notification', {
						"msg": "Please upload at least one file in dropzone"
					});
					return false;
				}
			}

			if (maxFileCount != 0 && dropzone.files.length > maxFileCount) {
				EventBus.$emit('error-notification', {
					"msg": 'You cannot upload more than ' + maxFileCount
						+ ' files'
				});
				return false;
			}

			for (var j = 0; j < dropzone.files.length; j++) {
				let file = dropzone.files[j];
				var ext = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
				if (fileArr.length > 0 && $.inArray(ext, fileArr) == -1) {
					EventBus.$emit('error-notification', {
						"msg": 'You cannot upload file with type ' + ext
					});
					return false;
				}

				form.append(dropName + '[' + j + ']', file);
				if (maxfilesize != 0
					&& dropzone.files[j].size / 1000000 > maxfilesize) {
					EventBus.$emit('error-notification', {
						"msg": 'You cannot upload file with size more than '
							+ maxfilesize + 'mb'
					});
					return false;
				}
			}
		}
		return true;
	},
	appendDropzoneData(form, dropzone) {
		let dropName = dropzone.options.paramName;
		let totalFileSize = 0;
		if (!this.isElementHidden(dropzone.element)) {
			let maxFileCount = 0;
			if ($(dropzone.element).parents("mfc-file-upload").attr("maxfiles") != null) {
				maxFileCount = parseInt($(dropzone.element).parents("mfc-file-upload").attr("maxfiles"));
			}

			let maxfilesize = 0;
			if ($(dropzone.element).parents("mfc-file-upload").attr("maxfilesize") != null) {
				maxfilesize = parseInt($(dropzone.element).parents("mfc-file-upload").attr("maxfilesize"));
			}

			let fileExt = $(dropzone.element).parents("mfc-file-upload").attr("filetypes");
			let fileArr = [];
			if (fileExt != null) {
				fileArr = JSON.parse(fileExt);
			}

			let isRequired = $(dropzone.element).parents("mfc-file-upload").attr("required");
			if (isRequired != null) {
				if (dropzone.files.length == 0) {
					EventBus.$emit('error-notification', {
						"msg": "Please upload at least one file in dropzone"
					});
					return false;
				}
			}

			if (maxFileCount != 0 && dropzone.files.length > maxFileCount) {

				EventBus.$emit('error-notification', {
					"msg": 'You cannot upload more than ' + maxFileCount
						+ ' files'
				});
				return false;
			}

			for (let j = 0; j < dropzone.files.length; j++) {
				let file = dropzone.files[j];
				let ext = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

				if (fileArr.length > 0 && $.inArray(ext, fileArr) == -1) {
					EventBus.$emit('error-notification', {
						"msg": 'You cannot upload file with type ' + ext
					});
					return false;
				}

				form.append(dropName + '[' + j + ']', file);
				if (maxfilesize != 0
					&& dropzone.files[j].size / 1000000 > maxfilesize) {
					EventBus.$emit('error-notification', {
						"msg": 'You cannot upload file with size more than '
							+ maxfilesize + 'mb'
					});
					return false;
				}
				totalFileSize = totalFileSize
					+ (dropzone.files[j].size / 1000000);
			}
			
		}
		if (totalFileSize > 50) {
			EventBus.$emit('error-notification', {
				"msg": 'Total file size should be less than 50MB.'
			});
			return false;
		}
		return true;
	},
	appendDropzoneDataExternal(form) {
		var novalidate = $("#rendererForm").attr('novalidate');
		if (novalidate != null && novalidate == "true") {
			novalidate = true;
		} else {
			novalidate = false;
		}
		var totalFileSize = 0;
		for (var i = 0; i < this.dropzoneComponents.length; i++) {
			let dropzone = this.dropzoneComponents[i];
			let dropName = dropzone.options.paramName;
			if (!this.isElementHidden(dropzone.element)) {
				let maxFileCount = 0;
				if ($(dropzone.element).attr("maxfiles") != null) {
					maxFileCount = parseInt($(dropzone.element).attr("maxfiles"));
				}

				let maxfilesize = 0;
				if ($(dropzone.element).attr("maxfilesize") != null) {
					maxfilesize = parseInt($(dropzone.element).attr("maxfilesize"));
				}

				let fileExt = $(dropzone.element).attr("filetypes");
				let fileArr = [];
				if (fileExt != null) {
					fileArr = JSON.parse(fileExt);
				}

				var isRequired = $(dropzone.element).attr("required");
				if (isRequired != null && !novalidate) {
					if (dropzone.files.length == 0) {
						EventBus.$emit('error-notification', {
							"msg": "Please upload at least one file in dropzone"
						});
						return false;
					}
				}

				if (maxFileCount != 0 && dropzone.files.length > maxFileCount) {

					EventBus.$emit('error-notification', {
						"msg": 'You cannot upload more than ' + maxFileCount
							+ ' files'
					});
					return false;
				}

				for (var j = 0; j < dropzone.files.length; j++) {
					let file = dropzone.files[j];
					var ext = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

					if (fileArr.length > 0 && $.inArray(ext, fileArr) == -1) {
						EventBus.$emit('error-notification', {
							"msg": 'You cannot upload file with type ' + ext
						});
						return false;
					}

					form.append(dropName + '[' + j + ']', file);
					if (maxfilesize != 0
						&& dropzone.files[j].size / 1000000 > maxfilesize) {
						EventBus.$emit('error-notification', {
							"msg": 'You cannot upload file with size more than '
								+ maxfilesize + 'mb'
						});
						return false;
					}
					totalFileSize = totalFileSize
						+ (dropzone.files[j].size / 1000000);
				}
			}
		}
		if (totalFileSize > 50) {
			EventBus.$emit('error-notification', {
				"msg": 'Total file size should be less than 50MB.'
			});
			return false;
		}
		return true;
	},
	applyFileUploadValidations(formId) {
		$(`#${formId} input[type=file]`).off('change').on("change", function () {
			var files = $(this)[0].files;
			var fileExtension = ['png', 'jpg', 'jpeg', 'pdf',
				'txt', 'zip', 'doc', 'docx', 'csv', 'xls',
				'xlsx'];

			let maxFileCount = 0;
			if ($(this).attr("maxfiles") != null) {
				maxFileCount = parseInt($(this).attr("maxfiles"));
			}
			let maxfilesize = 0;
			if ($(this).attr("maxfilesize") != null) {
				maxfilesize = parseInt($(this).attr("maxfilesize"));
			}

			let fileExt = $(this).attr("filetypes");
			if (fileExt != null) {
				fileExtension = JSON.parse(fileExt);
			}

			var isValid = true;
			var validFileName = ""
			var msg = "";
			if (files.length > 0) {
				msg = "1 File selected";
			}
			if (files.length > 1) {
				msg = files.length + " Files selected";
			}

			if (maxFileCount != 0 && files.length > maxFileCount) {
				this.value = '';

				EventBus.$emit('error-notification', {
					"msg": 'You cannot upload more than '
						+ maxFileCount + ' files'
				});
				return;
			}

			var ext = "";
			for (var i = 0; i < files.length; i++) {
				if (validFileName == "") {
					validFileName = files[i].name;
				} else {
					validFileName = validFileName + ","
						+ files[i].name;
				}
				var fileName = files[i].name.split('\\').pop();

				if (fileName.trim() != ""
					&& $.inArray(fileName.split('.').pop()
						.toLowerCase(), fileExtension) == -1) {
					ext = fileName.split('.').pop().toLowerCase();
					isValid = false;
				}

				if (maxfilesize != 0
					&& files[i].size / 1000000 >= maxfilesize) {
					this.value = '';
					$(this).find("[icon='clear_symbol']").trigger('click');

					EventBus.$emit('error-notification', {
						"msg": 'You cannot upload file with size more than '
							+ maxfilesize + 'mb'
					});
					return;
				}
			}
			if (!isValid) {
				this.value = '';
				$(this).find("[icon='clear_symbol']").trigger('click');

				if (fileExt != null) {
					EventBus.$emit('error-notification', {
						"msg": 'You cannot upload file with type '
							+ ext
					});
				} else {
					EventBus.$emit('error-notification', {
						"msg": 'Please select valid file'
					});
				}

				return false;
			}

		});
	},
	loadProcessLogoInList(processList) {
		for (let i = 0; i < processList.length; i++) {
			if (processList[i].processLogo != null && processList[i].processLogo.indexOf(":") != -1) {
				let procLogo = processList[i].processLogo.split(":");
				processList[i].processLogo = procLogo[0];
				processList[i].iconSet =
					procLogo.length > 1 && procLogo[1] != "" ? "fluency-color" : "";
			} else {
				processList[i].processLogo = "process";
				processList[i].iconSet = "";
			}
		}
	},
	updateFormUsingProcessVariables(variableList, variableMap) {
		var jsonObj = JSON.parse(variableList);
		for (var i in jsonObj) {
			var nameVal = jsonObj[i].name;
			var eleObj;
			if (nameVal && nameVal != "") {
				eleObj = $('body').find('[name="' + nameVal + '"]');
			} else {
				eleObj = "";
			}
			this.updateElementValue(eleObj, jsonObj[i], nameVal, variableMap);
		}
	},
	updateElementValue(eleObj, jsonObj, fieldName, variableMap) {
		var strTag = (eleObj && typeof eleObj.prop !== "undefined" && eleObj
			.prop("tagName")) ? eleObj.prop("tagName").toLowerCase() : "";
		switch (strTag) {
			case "input":
				var inputType = eleObj.attr("type").toLowerCase();
				switch (inputType) {
					case "radio":
					case "checkbox":
						var updateVal = jsonObj.value.split(",");
						for (let j = 0; j < eleObj.length; j++) {
							$(eleObj[j]).prop('checked', false);
						}
						for (let i in updateVal) {
							eleObj.filter(function () {
								return this.value == updateVal[i];
							}).prop("checked", true);
						}

						break;
					case "hidden":
						if (eleObj.hasClass("datepickerctrl") && eleObj[0]._flatpickr) {
							eleObj[0]._flatpickr.setDate(jsonObj.value);
						}
						break;
					default:
						$(eleObj).val(jsonObj.value);
						break;
				}
			case "textarea":
				if (jsonObj.value && jsonObj.value != "") {
					jsonObj.value = jsonObj.value.toString().replace(/\\"/g, '"')
						.replace(/\\r\\n/g, '\r\n');
				}
				$(eleObj).html(jsonObj.value);
				break;
			case "select":
				if ($(eleObj)[0].hasAttribute("datalistname") && $(eleObj).attr("multiple") == "multiple") {
					setTimeout(function () {
						var checkedArray = jsonObj.value.toString().split(',').map(
							function (item) {
								return item.trim();
							});
						eleObj[0].slim.set(checkedArray);
					}, 3000);
				} else if ($(eleObj)[0].hasAttribute("datalistname") && $(eleObj).attr("multiple") != "multiple") {
					setTimeout(function () {
						$(eleObj).val(jsonObj.value.toString());
					}, 3000);
				} else if ($(eleObj).attr("multiple") == "multiple") {
					var checkedArray = jsonObj.value.toString().split(',').map(
						function (item) {
							return item.trim();
						});
					eleObj[0].slim.set(checkedArray);
				} else {
					$(eleObj).val(jsonObj.value.toString());
				}
				break;
			default:
				// Find child elements by name
				if (jsonObj.value != undefined) {
					var updateVal = ("" + jsonObj.value).split(",");
					// Note Id of parent Div is name of child inputs(like radio button and
					// checklist)
					for (let i in updateVal) {
						var ele = $('body').find(
							"[name='" + jsonObj.name + "'][value='" + updateVal[i]
							+ "']");
						if (ele) {
							ele.attr("checked", "checked");
							ele.trigger('change');
						}
					}
				}
				break;
		}
	},
	renderFileDownloadLinks(dataJson) {
		var self = this;
		if (typeof dataJson == "string") {
			dataJson = JSON.parse(dataJson);
		}
		$("a[type='filedownload']").each(function (index, linkobj) {
			// Check if the file upload is multiple file upload
			if (dataJson[linkobj.name + "_originalFileName"] == null && dataJson[linkobj.name] != null) {
				self.showMultipleFiles(linkobj, dataJson[linkobj.name])
			} else {
				$(linkobj).html(dataJson[linkobj.name + "_originalFileName"]);
				$(linkobj).click(function () {
					if ($(this).hasClass("disableFileDownload")) {
						return;
					}
					var fileName = dataJson[linkobj.name + "_originalFileName"];
					var contentType = dataJson[linkobj.name + "_fileContentType"];
					var isFormDisabled = $("#fieldsetForForm").attr("disabled");
					if (isFormDisabled != undefined && isFormDisabled != "") {
						return;
					}
					if (fileName != undefined && contentType != undefined) {
						$("#fileName").val(fileName);
						$("#fieldName").val(linkobj.name);
						$("#contentType").val(contentType);
						$("#downloadFile").click();
						$("#fileName").val("");
						$("#contentType").val("");
					}
				});
			}

		});
	},
	updateDatepickerValues(mosaicData, formData) {
		// Use values from mosaicData to update values in formData
		$('#render-canvas mosaic-datetime-picker[datetype="datetime"]').each(function (index, ele) {
			let name = $(ele).attr('name');
			let submitFormat = $(ele).attr('date-format');
			// Check for ISO date format
			if (submitFormat.indexOf('Z') != -1) {
				let dateObj = (mosaicData[name] != null && mosaicData[name].length > 0) ?
					mosaicData[name][0] : null;
				if (dateObj != null) {
					let isoString = new Date(dateObj).toISOString();
					isoString = isoString.replace('.000', '');
					formData.forEach(item => {
						if (item['name'] == name) {
							item['value'] = isoString
						}
					});
				}
			}
		});
	},
	updateDateValuesForDraft(formDataArray) {
		$('#render-canvas mosaic-datetime-picker[datetype="datetime"]').each(function (index, ele) {
			let name = $(ele).attr('name');
			let submitFormat = $(ele).attr('date-format');
			// Check for ISO date format
			if (submitFormat.indexOf('Z') != -1) {
				formDataArray.forEach(item => {
					if (item['name'] == name && item['value'] != null && item['value'] != "") {
						let isoString = new Date(item['value']).toISOString();
						isoString = isoString.replace('.000', '');
						item['value'] = isoString;
					}
				});
			}
		});
	},
	updateFormDataForCheckbox(formData, formDataArray) {
		formData.forEach(function (item) {
			var existing = formDataArray.filter(function (v, i) {
				return v.name == item.name;
			});
			if (existing.length) {
				var existingIndex = formDataArray.indexOf(existing[0]);
				formDataArray[existingIndex].value = formDataArray[existingIndex].value.split(",").concat(item.value).toString();
			} else {
				formDataArray.push(item);
			}
		});
	},
	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	},
	getMomentDateString(isoDate) {
		if (isoDate != null && isoDate != '') {
			return moment(isoDate).format('DD/MM/YYYY hh:mm:ss')
		}
		return isoDate;
	},
	showMultipleFiles(linkObj, dataJson) {
		$.each(dataJson, function (ind, fileObj) {
			var a = document.createElement('a');
			$(a).addClass('name-link')
				.html("<div class='d-flex'><mcc-icon class='mr-1' name='download'></mcc-icon>" + fileObj["_originalFileName"] + "</div>");
			$(a).click(function () {
				if ($(this).hasClass("disableFileDownload")) {
					return;
				}
				var fileName = fileObj["_originalFileName"];
				var contentType = fileObj["_fileContentType"];
				var isFormDisabled = $("#fieldsetForForm").attr("disabled");
				if (isFormDisabled != undefined && isFormDisabled != "") {
					return;
				}
				if (fileName != undefined && contentType != undefined) {
					$("#fileName").val(fileName);
					$("#fieldName").val($(linkObj).attr('name') + "[" + ind + "]");
					$("#contentType").val(contentType);
					$("#downloadFile").click();
					$("#fileName").val("");
					$("#contentType").val("");

				}
			});

			$(linkObj).after($(a));
		})
		$(linkObj).html("");
	}, bindSummerNoteHintPatch() {

		$(".note-popover").mouseover(function () {
			$(".note-hint-item").unbind('click');
			$(".note-hint-item").on('click', function (e) {
				$(".note-hint-item").removeClass('active');
				$(this).addClass('active');
				var eventObj = jQuery.Event("keydown");
				eventObj.which = 13; // Enter
				eventObj.keyCode = 13;
				$('.note-editable').trigger(eventObj);
			});
		});
		$(".note-popover").mouseout(function () {
			$(".note-hint-item").unbind('click');
		});

	},
	isPropertyValid(attrName, errorMsg) {
		//.mc-row-repeater .child-wrapper .repeated-inputs
		let propertyArray = $("mfc-row-repeater .mcc-row-repeater").find("[" + attrName + "=" + attrName + "]").toArray();
		let isValidField = true;
		propertyArray.shift();
		propertyArray.forEach((rootField, i) => {
			propertyArray.forEach((otherFields, j) => {
				if (i != j && rootField.value.toLowerCase() == otherFields.value.toLowerCase()) {
					let comp = $(otherFields).find('input');
					displayErrorMessage($(comp), constantMessages.MESSAGES[errorMsg])
					comp[0].classList.add("ms-is-invalid")
					isValidField = false;
				}
			})
		})
		return isValidField;
	},
	removeExistingMessages(attrName, nameRegex, maxLength) {
		var pattern = new RegExp(nameRegex);
		var propertyArray = $("mfc-row-repeater .mcc-row-repeater").find("[" + attrName + "=" + attrName + "]");
		$.each(propertyArray, function (i, rootField) {
			var removeInValid = false;
			if (rootField.value != "" && pattern.test(rootField.value)) {
				removeInValid = true;
				$.each(propertyArray, function (j, otherFields) {
					if (i != j && rootField.value != "" && otherFields.value != "" && rootField.value.toLowerCase() == otherFields.value.toLowerCase()) {
						removeInValid = false;
					}
				});
			}
			if (rootField.value != "" && rootField.value.length > maxLength) {
				removeInValid = false;
			}
			if (removeInValid) {
				$(rootField).removeAttr('invalid');
			}
			else {

			}
		});
	},
	generateId() {
		let text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		for (var i = 0; i < 7; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	},
	validateEditableGrid() {
		for (let i=0;i<$('table[dataSource][data-mandatory="true"]').length;i++) {
			let table = $('table[dataSource][data-mandatory="true"]')[i];
			if($(table).children('tbody').children('tr.form-content-tr').length <= 0) {
				EventBus.$emit('error-notification', {
					"msg": `Please provide at least one row for ${$(table).parent().siblings("label.mfc-label").text()}`
				});
				return false;
			}
		}
		return true;
	},
}
export default Utils;